// Generated by Melange

import * as GrpcwebreadablestreamJs from "./webstreamparser/grpcwebreadablestream.js";
import * as Belt__Belt_List from "melange.belt/belt_List.js";
import * as Belt__Belt_Option from "melange.belt/belt_Option.js";
import * as Belt__Belt_Result from "melange.belt/belt_Result.js";
import * as Buhta_conf__Config from "../../conf/lib/Config.js";
import * as Caml_format from "melange.js/caml_format.js";
import * as Caml_js_exceptions from "melange.js/caml_js_exceptions.js";
import * as Caml_option from "melange.js/caml_option.js";
import * as Curry from "melange.js/curry.js";
import * as Fetch from "melange-fetch/Fetch.js";
import * as Google_rpc__Google_rpc_code from "../../../proto/third_party/google_rpc/gen/google_rpc_code.js";
import * as Google_rpc__Google_rpc_error_details from "../../../proto/third_party/google_rpc/gen/google_rpc_error_details.js";
import * as Google_rpc__Google_rpc_status from "../../../proto/third_party/google_rpc/gen/google_rpc_status.js";
import * as Ocaml_protoc_plugin__Reader from "../../../vendored/ocaml_protoc_plugin/reader.js";
import * as Ocaml_protoc_plugin__Service from "../../../vendored/ocaml_protoc_plugin/service.js";
import * as Ocaml_protoc_plugin__Writer from "../../../vendored/ocaml_protoc_plugin/writer.js";
import * as $$Promise from "../../../vendored/promise/promise.js";
import * as ReasonReactUpdate from "../../../vendored/reason-react-update/ReasonReactUpdate.js";
import * as Stdlib__Bytes from "melange/bytes.js";
import * as React from "react";

function parseResponse(prim) {
  return GrpcwebreadablestreamJs.parse(prim);
}

const binarytoa = ((b) => {
      return typeof btoa === "function"
        ? btoa(b)
        : Buffer.from(b, 'binary').toString('base64');
    }
);

const toBase64 = ((u8) => {
      return typeof btoa === "function"
        ? btoa(String.fromCharCode.apply(null, u8))
        : Buffer.from(u8).toString('base64');
    }
);

const fromBase64 = ((str) => {
      const uint8arr = typeof atob === "function"
         ? atob(str).split('')
         : Buffer.from(str, 'base64').toString('binary').split('');
      return uint8arr.map(c => c.charCodeAt(0));
    }
);

const UInt8Array = {
  toBase64: toBase64,
  fromBase64: fromBase64
};

const wrapRequest = ((serialized) => {
  var len = serialized.length;
  var bytesArray = [0, 0, 0, 0];
  var payload = new Uint8Array(5 + len);
  for (var i = 3; i >= 0; i--) {
    bytesArray[i] = (len % 256);
    len = len >>> 8;
  }
  payload.set(new Uint8Array(bytesArray), 1);
  payload.set(serialized, 5);
  return payload;
}
);

const unwrapResponse = ((responseText) => {
  const newPos = responseText.length - responseText.length % 4;
  return responseText.substr(0, newPos);
}
);

function decodeErrorStatusBin(base64text) {
  return Curry._1(Google_rpc__Google_rpc_status.Google.Rpc.Status.from_proto, Ocaml_protoc_plugin__Reader.create(undefined, undefined, Stdlib__Bytes.to_string(fromBase64(base64text))));
}

function decodeErrorInfo(errorDetails) {
  const errorInfo = Belt__Belt_List.keepMap(errorDetails, (function (errorDetail) {
          const errorInfo = Curry._1(Google_rpc__Google_rpc_error_details.Google.Rpc.ErrorInfo.from_proto, Ocaml_protoc_plugin__Reader.create(undefined, undefined, Stdlib__Bytes.to_string(errorDetail.value)));
          if (errorInfo.TAG === /* Ok */0) {
            return errorInfo._0;
          }
          
        }));
  if (errorInfo) {
    return errorInfo.hd;
  } else {
    return Curry._4(Google_rpc__Google_rpc_error_details.Google.Rpc.ErrorInfo.make, "0", undefined, undefined, undefined);
  }
}

function decodeFieldViolations(errorDetails) {
  return Belt__Belt_List.keepMap(errorDetails, (function (errorDetail) {
                const badRequest = Curry._1(Google_rpc__Google_rpc_error_details.Google.Rpc.BadRequest.FieldViolation.from_proto, Ocaml_protoc_plugin__Reader.create(undefined, undefined, Stdlib__Bytes.to_string(errorDetail.value)));
                if (badRequest.TAG === /* Ok */0) {
                  return badRequest._0;
                }
                
              }));
}

function convertJsPromise(jsPromise) {
  const rejectable = $$Promise.Js.fromBsPromise(jsPromise);
  const __x = $$Promise.Js.toResult(rejectable);
  return $$Promise.map(__x, (function (result) {
                if (result.TAG === /* Ok */0) {
                  return {
                          TAG: /* Ok */0,
                          _0: result._0
                        };
                } else {
                  return {
                          TAG: /* Error */1,
                          _0: {
                            statusCode: Curry._1(Google_rpc__Google_rpc_code.Google.Rpc.Code.to_int, /* UNKNOWN */2),
                            errorMessage: "Failed sending request",
                            errorInfo: Curry._4(Google_rpc__Google_rpc_error_details.Google.Rpc.ErrorInfo.make, "0", undefined, undefined, undefined),
                            fieldViolations: /* [] */0
                          }
                        };
                }
              }));
}

function parseGrpcWebHeaders(headers, statusCode) {
  const grpcMessage = Belt__Belt_Option.getWithDefault(Caml_option.null_to_opt(headers.get("grpc-message")), "There was an error from server");
  const grpcStatusDetailsBin = headers.get("grpc-status-details-bin");
  if (grpcStatusDetailsBin !== null) {
    const decodedErrorBin = decodeErrorStatusBin(grpcStatusDetailsBin);
    const defaultError_errorInfo = Curry._4(Google_rpc__Google_rpc_error_details.Google.Rpc.ErrorInfo.make, "0", undefined, undefined, undefined);
    const defaultError = {
      statusCode: statusCode,
      errorMessage: grpcMessage,
      errorInfo: defaultError_errorInfo,
      fieldViolations: /* [] */0
    };
    const error = Belt__Belt_Result.mapWithDefault(decodedErrorBin, defaultError, (function (decoded) {
            return {
                    statusCode: decoded.code,
                    errorMessage: decoded.message,
                    errorInfo: decodeErrorInfo(decoded.details),
                    fieldViolations: decodeFieldViolations(decoded.details)
                  };
          }));
    return $$Promise.resolved({
                TAG: /* Error */1,
                _0: error
              });
  }
  const error_errorInfo = Curry._4(Google_rpc__Google_rpc_error_details.Google.Rpc.ErrorInfo.make, "0", undefined, undefined, undefined);
  const error$1 = {
    statusCode: statusCode,
    errorMessage: grpcMessage,
    errorInfo: error_errorInfo,
    fieldViolations: /* [] */0
  };
  return $$Promise.resolved({
              TAG: /* Error */1,
              _0: error$1
            });
}

function makeRpc(request, f, headers, tenant, binaryOpt, url, languageOpt, param) {
  const binary = binaryOpt !== undefined ? binaryOpt : true;
  const language = languageOpt !== undefined ? languageOpt : "ru";
  const headers$1 = Belt__Belt_Option.getWithDefault(headers, new Headers());
  const contentType = binary ? "application/grpc-web+proto" : "application/grpc-web-text";
  headers$1.append("content-type", contentType);
  headers$1.append("x-grpc-web", "1");
  headers$1.append("accept", contentType);
  headers$1.append("accept-language", language);
  if (tenant !== undefined) {
    const operator = tenant.operator;
    const org = tenant.org;
    if (operator.id !== 0) {
      headers$1.append("x-operator-id", String(operator.id));
    }
    if (org.id !== 0) {
      headers$1.append("x-org-id", String(org.id));
    }
    
  }
  const match = Ocaml_protoc_plugin__Service.make_client_functions(f);
  const decode = match[1];
  const requestPayload = binarytoa(Ocaml_protoc_plugin__Writer.contents(Curry._1(match[0], request)));
  const payload = wrapRequest(fromBase64(requestPayload));
  const payload$1 = binary ? payload : toBase64(payload);
  const cfg = Buhta_conf__Config.getConfig(undefined);
  const promise = fetch(cfg.grpc_url + ("/api" + url), Fetch.RequestInit.make(/* Post */2, Caml_option.some(headers$1), Caml_option.some(payload$1), undefined, undefined, undefined, /* Include */2, undefined, undefined, undefined, undefined, undefined)(undefined));
  const __x = convertJsPromise(promise);
  const __x$1 = $$Promise.flatMap(__x, (function (response) {
          if (response.TAG !== /* Ok */0) {
            return $$Promise.resolved({
                        TAG: /* Error */1,
                        _0: {
                          statusCode: Curry._1(Google_rpc__Google_rpc_code.Google.Rpc.Code.to_int, /* UNKNOWN */2),
                          errorMessage: "Failed sending request",
                          errorInfo: Curry._4(Google_rpc__Google_rpc_error_details.Google.Rpc.ErrorInfo.make, "0", undefined, undefined, undefined),
                          fieldViolations: /* [] */0
                        }
                      });
          }
          const response$1 = response._0;
          const headers = response$1.headers;
          const grpcStatusCode = headers.get("grpc-status");
          if (grpcStatusCode !== null) {
            return parseGrpcWebHeaders(headers, Caml_format.caml_int_of_string(grpcStatusCode === null ? undefined : Caml_option.some(grpcStatusCode)));
          }
          const httpStatusCode = response$1.status;
          if (httpStatusCode !== 200) {
            if (httpStatusCode !== 401) {
              const __x = convertJsPromise(response$1.text());
              return $$Promise.map(__x, (function (res) {
                            let reasonText;
                            reasonText = res.TAG === /* Ok */0 ? res._0 : "Internal error";
                            return {
                                    TAG: /* Error */1,
                                    _0: {
                                      statusCode: Curry._1(Google_rpc__Google_rpc_code.Google.Rpc.Code.to_int, /* INTERNAL */14),
                                      errorMessage: reasonText,
                                      errorInfo: Curry._4(Google_rpc__Google_rpc_error_details.Google.Rpc.ErrorInfo.make, "0", undefined, undefined, undefined),
                                      fieldViolations: /* [] */0
                                    }
                                  };
                          }));
            }
            const __x$1 = convertJsPromise(response$1.text());
            return $$Promise.map(__x$1, (function (res) {
                          let reasonText;
                          reasonText = res.TAG === /* Ok */0 ? res._0 : "Unauthenticated";
                          return {
                                  TAG: /* Error */1,
                                  _0: {
                                    statusCode: Curry._1(Google_rpc__Google_rpc_code.Google.Rpc.Code.to_int, /* UNAUTHENTICATED */8),
                                    errorMessage: reasonText,
                                    errorInfo: Curry._4(Google_rpc__Google_rpc_error_details.Google.Rpc.ErrorInfo.make, "0", undefined, undefined, undefined),
                                    fieldViolations: /* [] */0
                                  }
                                };
                        }));
          }
          if (binary) {
            const __x$2 = convertJsPromise(response$1.arrayBuffer());
            return $$Promise.map(__x$2, (function (res) {
                          if (res.TAG === /* Ok */0) {
                            return {
                                    TAG: /* Ok */0,
                                    _0: {
                                      TAG: /* Bytes */0,
                                      _0: res._0
                                    }
                                  };
                          } else {
                            return {
                                    TAG: /* Error */1,
                                    _0: res._0
                                  };
                          }
                        }));
          }
          const __x$3 = convertJsPromise(response$1.text());
          return $$Promise.map(__x$3, (function (res) {
                        if (res.TAG === /* Ok */0) {
                          return {
                                  TAG: /* Ok */0,
                                  _0: {
                                    TAG: /* String */1,
                                    _0: res._0
                                  }
                                };
                        } else {
                          return {
                                  TAG: /* Error */1,
                                  _0: res._0
                                };
                        }
                      }));
        }));
  return $$Promise.flatMap(__x$1, (function (result) {
                if (result.TAG !== /* Ok */0) {
                  return $$Promise.resolved({
                              TAG: /* Error */1,
                              _0: result._0
                            });
                }
                const parsed = result._0;
                let tmp;
                tmp = parsed.TAG === /* Bytes */0 ? parsed._0 : fromBase64(unwrapResponse(parsed._0));
                const parsedStream = GrpcwebreadablestreamJs.parse(tmp);
                let buf;
                try {
                  buf = Curry._1(decode, Ocaml_protoc_plugin__Reader.create(undefined, undefined, Stdlib__Bytes.to_string(parsedStream)));
                }
                catch (raw_exn){
                  const exn = Caml_js_exceptions.internalToOCamlException(raw_exn);
                  console.log("decode exn", exn);
                  throw new Caml_js_exceptions.MelangeError(exn.MEL_EXN_ID, exn);
                }
                if (buf.TAG === /* Ok */0) {
                  return $$Promise.resolved({
                              TAG: /* Ok */0,
                              _0: buf._0
                            });
                } else {
                  return $$Promise.resolved({
                              TAG: /* Error */1,
                              _0: {
                                statusCode: Curry._1(Google_rpc__Google_rpc_code.Google.Rpc.Code.to_int, /* UNKNOWN */2),
                                errorMessage: "Failed decoding server response",
                                errorInfo: Curry._4(Google_rpc__Google_rpc_error_details.Google.Rpc.ErrorInfo.make, "0", undefined, undefined, undefined),
                                fieldViolations: /* [] */0
                              }
                            });
                }
              }));
}

function useRpc(f, request, url, binaryOpt, headers, param) {
  const binary = binaryOpt !== undefined ? binaryOpt : true;
  const match = ReasonReactUpdate.useReducer("Loading", (function (action, param) {
          if (typeof action === "string") {
            return {
                    TAG: /* UpdateWithSideEffects */1,
                    _0: "Loading",
                    _1: (function (param) {
                        const send = param.send;
                        const __x = makeRpc(request, f, headers, undefined, binary, url, undefined, undefined);
                        $$Promise.get(__x, (function (res) {
                                if (res.TAG === /* Ok */0) {
                                  return Curry._1(send, {
                                              NAME: "Fetched",
                                              VAL: res._0
                                            });
                                } else {
                                  return Curry._1(send, {
                                              NAME: "Failed",
                                              VAL: res._0
                                            });
                                }
                              }));
                      })
                  };
          } else if (action.NAME === "Failed") {
            return {
                    TAG: /* Update */0,
                    _0: {
                      NAME: "Error",
                      VAL: action.VAL
                    }
                  };
          } else {
            return {
                    TAG: /* Update */0,
                    _0: {
                      NAME: "Data",
                      VAL: action.VAL
                    }
                  };
          }
        }));
  const dispatch = match[1];
  React.useEffect((function () {
          Curry._1(dispatch, "Fetch");
        }), [request]);
  return match[0];
}

export {
  parseResponse ,
  binarytoa ,
  UInt8Array ,
  wrapRequest ,
  unwrapResponse ,
  decodeErrorStatusBin ,
  decodeErrorInfo ,
  decodeFieldViolations ,
  convertJsPromise ,
  parseGrpcWebHeaders ,
  makeRpc ,
  useRpc ,
}
/* ./webstreamparser/grpcwebreadablestream.js Not a pure module */
